import { setLabelsVisible } from 'components/Graph/GraphApp/GraphEdge';
import { setLabelVisible } from 'components/Graph/GraphApp/GraphNode';
import type { GraphRendererPlugin } from 'components/Graph/GraphApp/plugins/GraphRendererPlugin';

const MIN_SCALE_TO_SHOW_LABELS = 0.4;

export const hideLabelsOnFarZoom: GraphRendererPlugin = (pluginInterface) => {
  let labelsVisible = true;

  pluginInterface.viewport.on('zoomed', () => {
    const scale = pluginInterface.viewport.scale.x;
    if (labelsVisible !== scale > MIN_SCALE_TO_SHOW_LABELS) {
      labelsVisible = !labelsVisible;
      // biome-ignore lint/complexity/noForEach: iteration over Map
      pluginInterface.edgeDisplayObjects.forEach((edge) => {
        setLabelsVisible(edge, labelsVisible, 'FAR_ZOOM');
      });
      // biome-ignore lint/complexity/noForEach: iteration over Map
      pluginInterface.nodeDisplayObjects.forEach((node) => {
        setLabelVisible(node, labelsVisible, 'FAR_ZOOM');
      });
    }
  });
};
